import { memo } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
  Alert,
} from "@mui/material";
import { CheckCircle2, AlertCircle } from "lucide-react";
import PreviewSectionCard from "./PreviewSectionCard";
import UploadedFilesSection from "./UploadedFilesSection";

const PreviewStep = memo(({ formData, uploadedFiles, financierType }) => {
  const getTotalDocuments = () => {
    let count = 0;
    Object.values(uploadedFiles).forEach((doc) => {
      if (doc.single) count++;
      if (doc.front) count++;
      if (doc.back) count++;
      if (Array.isArray(doc.multiple)) count += doc.multiple.length;
    });
    return count;
  };

  return (
    <Box>
      <Alert
        severity="info"
        sx={{ mb: 3, display: "flex", alignItems: "center", gap: 1 }}
        icon={<AlertCircle size={20} />}
      >
        <Typography variant="body2">
          Please review all information below. You can go back to edit if
          needed.
        </Typography>
      </Alert>

      <PreviewSectionCard
        title="Driver Details"
        data={{
          driverName: formData.driverName,
          mobileNumber: formData.mobileNumber,
          alternateMobileNumber: formData.alternateMobileNumber || "--",
          residentialAddress: formData.residentialAddress,
          age: formData.age ? `${formData.age} years` : "",
          vehicleFinanced: formData.vehicleFinanced,
          otherInformation: formData.otherInformation || null,
        }}
      />

      <PreviewSectionCard
        title="Vehicle Financier Details"
        data={{
          vehicleFinancierName: formData.vehicleFinancierName,
          vehicleFinancierAddress: formData.vehicleFinancierAddress,
          vehicleFinancierPhone: formData.vehicleFinancierPhone,
        }}
      />

      <Divider sx={{ my: 3 }} />

      <Typography
        variant="body2"
        sx={{
          fontWeight: 700,
          color: "#1f2937",
          mb: 2,
          fontSize: "16px",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <CheckCircle2 style={{ fontSize: "20px", color: "#059669" }} />
        Documents
      </Typography>
      <UploadedFilesSection uploadedFiles={uploadedFiles} />

      <Card
        sx={{ mb: 3, backgroundColor: "#eff6ff", border: "2px solid #93c5fd" }}
      >
        <CardContent>
          <Typography
            variant="body2"
            sx={{
              color: "#1e40af",
              fontWeight: 600,
              mb: 1.5,
              fontSize: "16px",
            }}
          >
            Summary
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography
              variant="caption"
              sx={{
                color: "#1e40af",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <span style={{ fontWeight: 600 }}>•</span>
              <span>
                Financier Type: <strong>{financierType}</strong>
              </span>
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "#1e40af",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <span style={{ fontWeight: 600 }}>•</span>
              <span>
                Total Documents Uploaded:{" "}
                <strong>
                  {getTotalDocuments()} file
                  {getTotalDocuments() !== 1 ? "s" : ""}
                </strong>
              </span>
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "#1e40af",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <span style={{ fontWeight: 600 }}>•</span>
              <span>All information verified and ready for submission</span>
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
});

export default PreviewStep;
